import { lazy } from 'react';

export const UserContactInformation = lazy(() => import('./pages/UserContactInformation'));
